export default __webpack_public_path__ + "static/media/Map.d53743ad.webp";